var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File / File_Check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.50033 12.5L9.16699 14.1667L12.5003 10.8333M10.8337 2.50072C10.7541 2.5 10.6647 2.5 10.5626 2.5H6.83382C5.9004 2.5 5.43334 2.5 5.07682 2.68166C4.76322 2.84144 4.50844 3.09623 4.34865 3.40983C4.16699 3.76635 4.16699 4.23341 4.16699 5.16683V14.8335C4.16699 15.7669 4.16699 16.2334 4.34865 16.5899C4.50844 16.9035 4.76322 17.1587 5.07682 17.3185C5.433 17.5 5.8995 17.5 6.83111 17.5L13.1696 17.5C14.1012 17.5 14.567 17.5 14.9232 17.3185C15.2368 17.1587 15.4924 16.9035 15.6522 16.5899C15.8337 16.2337 15.8337 15.7679 15.8337 14.8363V7.7714C15.8337 7.66913 15.8336 7.57967 15.8329 7.5M10.8337 2.50072C11.0717 2.50289 11.2223 2.51154 11.366 2.54605C11.5361 2.58688 11.6985 2.65439 11.8477 2.74577C12.0158 2.8488 12.1602 2.99318 12.4482 3.28125L15.0528 5.88582C15.3411 6.17407 15.4844 6.3178 15.5875 6.48599C15.6788 6.63512 15.7464 6.79771 15.7873 6.96777C15.8218 7.11147 15.8306 7.26209 15.8329 7.5M10.8337 2.50072V4.83333C10.8337 5.76675 10.8337 6.23314 11.0153 6.58966C11.1751 6.90326 11.4299 7.15873 11.7435 7.31852C12.0997 7.5 12.5662 7.5 13.4978 7.5H15.8329M15.8329 7.5H15.8338",
    stroke: "#B4B4C4",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.7d68bf9660383b3beda8528fdc306eab.svg";
export { ForwardRef as ReactComponent };